module.exports = __webpack_public_path__ + "img/mi_saison.882ab111.svg";